import { render } from "./Steps.vue?vue&type=template&id=6e70879a"
import script from "./Steps.vue?vue&type=script&lang=ts"
export * from "./Steps.vue?vue&type=script&lang=ts"
script.render = render

export default script